import React from 'react';

import { PageHeader } from 'inside-out/components/shared/pageHeader';
import { PageNav } from 'inside-out/components/shared/pageNav';
import AboutUsBG from 'inside-out/images/about-us/bg.svg';

import { pink, aqua } from 'inside-out/global-styles';

export const CommonPageHeader = (
	<PageHeader
		background={`${pink} url(${AboutUsBG}) no-repeat bottom right`}
		titleText="We are InsideOut"
		titleTextColor="#fff"
		pageNav={
			<PageNav
				textColor="#fff"
				activeTextColor="#fff"
				activeUnderlineColor={aqua}
				links={[
					{
						to: '/about-us',
						text: 'Mission, values and history ',
					},
					{
						to: '/about-us/what-we-do',
						text: 'What we do',
					},
					{
						to: '/about-us/insideout-team',
						text: 'InsideOut Team',
					},
					{
						to: '/about-us/ambassadors-and-champions',
						text: 'Ambassadors & Champions',
					},
				]}
			/>
		}
	/>
);



// WEBPACK FOOTER //
// ./src/components/about-us/commonPageHeader/component.js